import { useState, useEffect } from 'react';

const useSelfPayDiscount = (environment) => {
    let discount = 0;
    //const [selfPayDiscount, setSelfPayDiscount] = useState({ selfPayDicsount: .6 });

    //useEffect(() => {
        if (environment) {
            //props.clear();
            discount = environment.toLowerCase().indexOf("htpn") !== -1 ? .7 : .6;
            //setSelfPayDiscount({ selfPayDicsount: Number(discount)});
        }//'no previous user'
   // }, [environment]);
    console.info(`useSelfPayDiscount environment: '${environment}' discount: ''${Number(discount)}`);
    return Number(discount);
}

export default useSelfPayDiscount;